<template>
    <div class="rental-company-create">
        <data-form title="Add Approved Rental Company"
                   tag="rental-company-create"
                   save-button-label="Submit"
                   :field-model="rentalCompanyFields"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   cancelRoute="/rentalcompany/list"
                   submit-success-message="Rental Company Created"
                   submit-error-message="Error Creating Rental Company">
        </data-form>
    </div>
</template>

<script>

import RentalCompanyFields from '@/models/RentalCompany'

export default {
    name: 'RentalCompanyCreate',
    data () {
        return {
            rentalCompanyFields: RentalCompanyFields,
            fieldGroups: [['name', 'address_1', 'address_2', 'city', 'state', 'zip', 'phone', 'email', 'status']]
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'rental-company', modelInstance)
                .then((response) => {
                    this.$router.push(`/rentalcompany/list`)
                })
        }
    }
}
</script>

<style scoped>

</style>